import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

/**
 * El backend ya filtra "finalizadas vendidas" (winner + finishTime <= ahora)
 * y proyecta `finishTime` en milisegundos y `winnerName` sin el email. El
 * filtro cliente se retiró: usaba `winner`, campo que F7 eliminó de la
 * proyección por PII (DOM-AN-005), y descartaba todas las filas.
 */
export const getFinishedAuctionsSoldByDealershipIdV2 = async (context = {}) => {
  const requestedApp = context.activeApp;
  const isGroupContext = requestedApp === 'group_web';
  const groupId = isGroupContext
    ? context.activeGroupId || context.groupId
    : null;
  const operatingUnitId = !isGroupContext ? context.activeUnitId : null;
  const dealershipId = !isGroupContext
    ? context.dealershipId || context.dealership
    : null;

  if (!['dealership_web', 'group_web'].includes(requestedApp)) {
    return { success: 'no', message: 'Contexto de aplicación inválido' };
  }
  if ((!isGroupContext && !operatingUnitId && !dealershipId) || (isGroupContext && !groupId)) {
    return { success: 'no', message: 'Contexto operativo incompleto' };
  }
  try {
    const getFinishedAuctionsFn = httpsCallable(functions, 'getFinishedAuctionsSoldByDealershipIdV2');
    const result = await getFinishedAuctionsFn({
      dealershipId: dealershipId || undefined,
      operatingUnitId: operatingUnitId || undefined,
      groupId: groupId || undefined,
      requestedApp,
    });
    return result.data;
  } catch (error) {
    console.error('Error obteniendo subastas finalizadas:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
